//for profrssionals page

import  { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

import './fixed.css';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Phone from "./graph/Phone";
import { Modal } from "react-bootstrap";
import Terms, { TermsInner } from "../terms/terms";
import i18n from "../../../config/i18n";
import { useForm, ValidationError } from '@formspree/react';
import Animate from "../about/Animate";
import React from "react";
import { getProviders } from "../../services/providers.service";
import { toAbsoluteUrl } from "../../tools/AssetHelpers";
import { getMetadata } from "../../services/sim.service";

// Cannot find name 'TweenMax
// import LocomotiveScroll from 'locomotive-scroll';
// import 'react-locomotive-scroll/dist/locomotive-scroll.min.css';

const Fixed = () => {
    const {t, i18n} = useTranslation();
    const [providers, setProviders] = React.useState<any>([]);
    const [loading, setLoading] = React.useState(true);

    const fetchProviders = async () => {
        const response = await getProviders(i18n.language);
        // make the id 9 in place of 16 and 16 in place of 9
        console.log(response.returnData);
        const temp = response.returnData[7];
        console.log(temp);
        response.returnData[7] = response.returnData[2];
        response.returnData[2] = temp;
        console.log(response.returnData);
        setProviders(response.returnData.slice(0, 10));
        setLoading(false);
    }
   


    React.useEffect(() => {
        fetchProviders();
    }
    , [])

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {

    }, [])

    const [isAnimating, setIsAnimating] = useState(false)
    const [theme, setTheme] = useState<'light' | 'dark'>('light'); // default is light

    return (
        <>
    <div className={`professionals__section ${theme}-mode`}>
      <div className='container '>
        <Header />
        {/* Theme toggle button (optional, remove if not needed) */}
        <button
          className="theme-switch-btn"
          onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
          aria-label="Switch theme"
        >
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
                <div className="row h-100 prof py-5">
          <div className="col-lg-6 col-12">
            <Forum
              animate={isAnimating}
              setAnimate={(value: boolean) => {
                setIsAnimating(value)
              }}
              theme={theme}
            />
          </div>
          <div className="col-lg-6 col-12 d-none d-lg-block">
            <Animate
              animate={isAnimating}
              setAnimate={(value: boolean) => {
                setIsAnimating(value)
              }}
              theme={theme}
            >
              <div className="professionals__hero">
                <img src={theme === 'light' ? "/media/fixed/1.svg" : "/media/fixed/1.svg"} alt="hero" className="w-100 h-100" />
              </div>
            </Animate>
            {/* <Phone animate={isAnimating} setAnimate={setIsAnimating}/> */}
          </div>
          <div className='col-12 col-lg-6 order-1 order-lg-2 justify-content-center d-flex align-items-center'>
          
          </div>
        </div>

            </div>
        </div>
                {/* 
                <div className="professionals__section">
                    <div className="professionals__wrapper container h-100">
                      <Header />
                      <Hero />
                    </div>
                </div>
                  <div className='buttom_bg'>
                  <svg  viewBox="0 0 2579 370" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.669983 0L498.094 331.465C547.169 364.168 607.12 376.295 665.046 365.238L2578.6 0H0.669983Z" fill="#2f1952"/>
                  </svg>
                </div>
                <div className='container mt-5'>
                  
                <Contact />
                <Partners />
                </div> 
                */}

            
            <Footer />
        </>
    )
}

export default Fixed;

 


const Forum = ({
  animate,
  setAnimate,
  theme,
}: {
  animate: boolean;
  setAnimate: any;
  theme: 'light' | 'dark';
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [serviceIndex, setServiceIndex] = useState(0);
  const [choiceIndex, setChoiceIndex] = useState(0);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
      interface ServiceOptionData {
        capacity: number;
        onNetMin: number;
        offNetMin: number;
        onNetSMS: number;
        offNetSMS: number;
        price: number;
      }
      
      interface Service {
        title: string;
        description: string;
        image: string;
        optionText: string;
        options?: string[];
        optionsData?: ServiceOptionData[];
        outerElement?: JSX.Element;
      }
      
      interface Step {
        title?: string;
        description?: string;
        child: () => JSX.Element;
      }
      const {t, i18n} = useTranslation();

      const services: Service[] = [
        {
          title: t("fixedService.services.routerTitle")+"",
          description: t("fixedService.services.routerDescription")+"",
          image: theme === 'light' ? "icons/router_black.svg" : "icons/router.svg",
          optionText: t("fixedService.services.speed")+"",
          options: [
            "4G ( "+t("global.unlimited")+" )",
            "5G ( "+t("global.unlimited")+" )",
            "2 "+t("global.GB"),
            "5 "+t("global.GB"),
            "10 "+t("global.GB"),
            "50 "+t("global.GB"),
            "100 "+t("global.GB"),
            "300 "+t("global.GB"),
            "600 "+t("global.GB")
          ],
        },
        {
          title: t("fixedService.services.fiberTitle")+"",
          description: t("fixedService.services.fiberDescription")+"",
          image: theme === 'light' ? "icons/optical-fiber_black.svg" : "icons/optical-fiber 1.svg",
          optionText: t("fixedService.services.speed")+"",
          options: [
            "500 "+t("fixedService.services.speed"),
            "200 "+t("fixedService.services.speed"),
            "100 "+t("fixedService.services.speed")
          ],
          
        },
        {
          title: t("fixedService.services.simTitle")+"",
          description: "",
          image: theme === 'light' ? "icons/simcard_black.svg" : "icons/simcard.svg",
          optionText: t("fixedService.services.choosePlan")+"",
          optionsData: [
            {
              capacity: 100,
              onNetMin: 2411,
              offNetMin: 425,
              onNetSMS: 5362,
              offNetSMS: 632,
              price: 2.62,
            },
            {
              capacity: 100,
              onNetMin: 2411,
              offNetMin: 425,
              onNetSMS: 5362,
              offNetSMS: 632,
              price: 2.62,
            },
            {
              capacity: 100,
              onNetMin: 2411,
              offNetMin: 425,
              onNetSMS: 5362,
              offNetSMS: 632,
              price: 2.62,
            },
            {
              capacity: 100,
              onNetMin: 2411,
              offNetMin: 425,
              onNetSMS: 5362,
              offNetSMS: 632,
              price: 2.62,
            },
          ],
          outerElement: (
            <div className="form-group mb-3">
              <label htmlFor="exampleTextField">{t("fixedService.services.simNumber")}</label>
              <input
                type="number"
                className="form-control"
                id="exampleTextField"
                placeholder="1"
              />
            </div>
          ),
        },
      ];
    
      const steps : Step[] = [
  {
    title: t("fixedService.services.provider") ?? "",
    description: t("fixedService.services.providerQuestion") ?? "",
    child: () => (
      <ServiceOptions
        stepIndex={stepIndex}
        setStepIndex={setStepIndex}
        choiceIndex={choiceIndex}
        setChoiceIndex={setChoiceIndex}
        serviceIndex={serviceIndex}
        services={[
          {
            title: t("fixedService.services.provider"),
            description: t("fixedService.services.providerQuestion"),
            image: "",
            optionText: t("fixedService.services.provider"),
            options: [t("fixedService.services.salam"), t("fixedService.services.stc")],
            optionsImages: [
              toAbsoluteUrl("media/logos/salam.png"),
              toAbsoluteUrl("media/logos/stc.png")
            ],
          }
        ]}
      />
    ),
  },
  {
    title: t("fixedService.services.tygoFixed")+"",
    description: t("fixedService.services.regularUse")+"",
    child: () => (
      
      <Services
        services={[
          {
            title: t("fixedService.services.routerTitle"),
            description: "",
            image: theme === 'light' ? "icons/router_black.svg" : "icons/router.svg",
          },
          {
            title: t("fixedService.services.fiberTitle"),
            description: "",
            image: theme === 'light' ? "icons/optical-fiber_black.svg" : "icons/optical-fiber 1.svg",
          }
        ]}
        stepIndex={stepIndex}
        setStepIndex={setStepIndex}
        setServiceIndex={setServiceIndex}
        theme={theme}
      />
    ),
  },
  {
    title: t("fixedService.services.speed")+"",
    description: "",
    child: () => (
      <ServiceOptions
        stepIndex={stepIndex}
        setStepIndex={setStepIndex}
        choiceIndex={choiceIndex}
        setChoiceIndex={setChoiceIndex}
        serviceIndex={serviceIndex}
        services={[
          {
            title: "Router Options",
            description: "",
            image: "",
            optionText: t("business.services.speed")+"",
            options: [
              "4G ( "+t("global.unlimited")+" )",
              "5G ( "+t("global.unlimited")+" )",
              "2 "+t("global.GB"),
              "5 "+t("global.GB"),
              "10 "+t("global.GB"),
              "50 "+t("global.GB"), 
              "100 "+t("global.GB"),
              "300 "+t("global.GB"),
              "600 "+t("global.GB")
            ]
          },
          {
            title: "Fiber Options",
            description: "",
            image: "",
            optionText: t("business.services.speed")+"",
            options: [
              "500 "+t("fixedService.services.speed"),
              "200 "+t("fixedService.services.speed"),
              "100 "+t("fixedService.services.speed")
            ]
          }
        ][serviceIndex]
      }
      />
    ),
  },
  {
    title: t("fixedService.login.title")+"",
    description: t("fixedService.login.description")+"",
    child: () => <Login stepIndex={stepIndex} setStepIndex={setStepIndex} setShowSuccessDialog={setShowSuccessDialog} />,
  },
  {
    child: () => (
      <div className="d-flex h-100 align-items-center">
        <div className="pb-5 fs-4 text-center">
          <img src="/media/done.gif" className="w-50"/>
          <br/>
          {t("fixedService.done")}
        </div>
      </div>
    ),
  },
];
      
      
      const [innerComponent, setInnerComponent] = useState(<></>);
    
      useEffect(() => {
        setInnerComponent(steps[stepIndex].child);
      }, [stepIndex, choiceIndex]);
    
      useEffect(() => {
        setAnimate(true);
      }, [stepIndex])
    
      return (
        <div className="from-wrapper">
          <div className={`d-flex p-4 flex-column align-items-start row-gap-3 overflow-x-hidden overflow-y-auto${theme === 'dark' ? ' card-bg' : ''}`}>
            <Indicators active={stepIndex} length={4} />
            {innerComponent && (
              <InnerContent
                step={steps[stepIndex]}
                stepIndex={stepIndex}
                setStepIndex={setStepIndex}
                child={innerComponent}
                theme={theme}
              />
            )}
          </div>
          <SuccessDialog 
            show={showSuccessDialog}
            onHide={() => setShowSuccessDialog(false)}
          />
        </div>
      );
      }
      const CheckBox = ({ checked } : {checked: boolean}) => {
        return (
          // <label class="check_box my-2 p-lg-4 p-3 align-items-center " style="min-height: 80px;"><input type="checkbox" value="4"><span class="mx-1"></span><span class="">just the basics</span></label>
          <div className="checkbox">
            <div className={`checked ${checked ? "" : "hidden"}`}></div>
          </div>
        );
      };
      
      const Services = ({
        services,
        stepIndex,
        setStepIndex,
        setServiceIndex,
        theme
      }: {
        services: any,
        stepIndex: number,
        setStepIndex: Dispatch<SetStateAction<number>>,
        setServiceIndex: Dispatch<SetStateAction<number>>,
        theme: 'light' | 'dark'
      }) => {
        const { t, i18n } = useTranslation();
        const onStepIndexChange = (index: number) => {
          setStepIndex(index);
        };
      
        const onServiceIndexChange = (index: number) => {
          setServiceIndex(index);
        };
      
        return (
          <div className="services">
            <h2 className="fs-5 fw-semibold my-4">
              {t("fixedService.services.services")}
              </h2>
            <div className="list row align-items-stretch">
              {services.map((item: any, index: number) => (
                <div className="col-12 col-sm-6 pb-4 d-box">
                  <div
                    className="service h-100 d-flex p-4 position-relative flex-column align-items-start"
                    key={index}
                    onClick={() => {
                      onServiceIndexChange(index);
                      onStepIndexChange(stepIndex + 1);
                    }}
                  >
                    <img className="logo" src={item.image} alt={item.title} />
                    <h3 className="fs-6 fw-semibold">{item.title}</h3>
                    <img className="next" src={`icons/arrow-${i18n.dir()}${theme === 'light' ? '_black' : ''}.svg`} alt="next" />
                    
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      };
      
      const ServiceOptions = ({
        stepIndex,
        setStepIndex,
        choiceIndex,
        setChoiceIndex,
        serviceIndex,
        services,
      } : {
        stepIndex: number,
        setStepIndex: Dispatch<SetStateAction<number>>,
        choiceIndex: number,
        setChoiceIndex: Dispatch<SetStateAction<number>>,
        serviceIndex: number,
        services: any
      }) => {
        const OnChoiceClicked = (index: number) => {
          setChoiceIndex(index);
        };
        const { t, i18n } = useTranslation();

        // Check if services is an array or single object
        const currentService = Array.isArray(services) ? services[serviceIndex] : services;
        
        return (
          <>
            <div className={"options mb-2 pt-2 overflow-y-auto position-relative flex-grow-1"}>
              {currentService.outerElement && currentService.outerElement}
              
              <h2 className="fs-5 py-2 fw-semibold">
                {currentService.optionText}
              </h2>

              <div className="togglesList">
                {currentService.options?.map((option: string, index: number) => (
                  <div
                    className="option d-flex column-gap-3 align-items-center"
                    key={index}
                    onClick={() => {
                      OnChoiceClicked(index);
                    }}
                  >
                    <CheckBox checked={index === choiceIndex} />
                    {currentService.optionsImages && (
                      <img src={currentService.optionsImages[index]} alt={option} />
                    )}
                    <p>{option}</p>
                  </div>
                ))}
              </div>
            </div>
            <div
              className="button"
              onClick={() => setStepIndex(stepIndex + 1)}
            >
              {t("fixedService.services.next")}
            </div>
          </>
        );
      };
      
      const InnerContent = ({
        step,
        stepIndex,
        setStepIndex,
        child,
        theme
      }: {
        step: any,
        stepIndex: number,
        setStepIndex: Dispatch<SetStateAction<number>>,
        child: JSX.Element,
        theme: 'light' | 'dark'
      }) => {
        return (
          <div className="content d-flex flex-column w-100 h-100">
            {stepIndex === 0 ? (
              <></>
            ) : (
              <img
                className="back mb-2"
                src={`icons/arrow-${i18n.dir()}${theme === 'light' ? '_black' : ''}.svg`}
                alt="back"
                onClick={() => {
                  setStepIndex(stepIndex - 1);
                  console.log(stepIndex);
                }}
              />
            )}
            {step.title != null && step.description != null ? (
              <div className="title_">
                <h1 className="fw-bold mb-3">{step.title}</h1>
                <p>{step.description}</p>
              </div>
            ) : (
              <></>
            )}
            {child}
          </div>
        );
      };
   
    
      const Login = ({ 
        stepIndex, 
        setStepIndex,
        setShowSuccessDialog 
      }: {
        stepIndex: number,
        setStepIndex: Dispatch<SetStateAction<number>>,
        setShowSuccessDialog: Dispatch<SetStateAction<boolean>>
      }) => {
        const {t} = useTranslation();
        const [state, handleSubmit] = useForm("meqyvlld");
        const [number, setNumber] = useState('');
        const [selectedCode, setSelectedCode] = useState('966'); // Default to Saudi Arabia
        const [errorNumber, setErrorNumber] = useState<string | null>(null);
        
        const [identities, setIdentities] = useState<any[]>([]);
        const [searchQuery, setSearchQuery] = useState('');
        const [selectedIdentity, setSelectedIdentity] = useState<any>(null);
        const [showCountryModal, setShowCountryModal] = useState(false);

        useEffect(() => {
          const d = async () => {
            try {
              const response = await getMetadata(i18n.language);
              setIdentities(response?.data.returnData || []);
            } catch (error) {
              console.error('Error fetching metadata:', error);
            }
          };
          d();
        }, [i18n.language]);
        
        const filteredIdentities = identities.filter(identity =>
          (i18n.language === "ar"
            ? identity.nameAr
            : identity.nameEN
          )
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );
        
        if (state.succeeded) {
          setShowSuccessDialog(true);
        }
        
        return (
          <>
          <form onSubmit={handleSubmit}>
            <div className="row group">
              <div className="form-group my-3 group col-12 col-sm-6">
                <label htmlFor="name">{t("fixedService.login.name")}</label>
                
                <input
                  required
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder={t("fixedService.login.name")+""}
                />
                <ValidationError 
                  prefix="Name"
                  field="name"
                  errors={state.errors}
                />
              </div>
              <div className="form-group my-3 group col-12 col-sm-6">
                <label htmlFor="email">{t("fixedService.login.email")}</label>
                <input
                  required
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder={t("fixedService.login.emailExample")+""}
                />
                <ValidationError 
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
              </div>
            </div>
            <div className="row group">
              <div className="form-group col-12 col-sm-6">
                <label htmlFor="city">{t("fixedService.login.city")}</label>
                <input
                  required
                  type="text"
                  className="form-control"
                  id="city"
                  name="city"
                  placeholder={t("fixedService.login.city")+""}
                />
                <ValidationError
                  prefix="City"
                  field="city"
                  errors={state.errors}
                />
              </div>
               <div className="form-group col-12 col-sm-6">
                <label htmlFor="nationality">{t("fixedService.services.nationality")}</label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="form-control"
                    id="nationality"
                    name="nationality"
                    readOnly
                    required
                    value={
                      selectedIdentity
                        ? (i18n.language === "ar" ? selectedIdentity.nameAr : selectedIdentity.nameEN)
                        : ""
                    }
                    placeholder={t("fixedService.services.nationalityExample") + ""}
                    style={{ paddingLeft: selectedIdentity ? 44 : 12, cursor: "pointer", backgroundColor: "#fff" }}
                    onClick={() => setShowCountryModal(true)}
                  />
                  {selectedIdentity && (
                    <img
                      src={selectedIdentity.flagImageUrl}
                      alt={i18n.language === "ar" ? selectedIdentity.nameAr : selectedIdentity.nameEN}
                      style={{
                        width: 30,
                        position: "absolute",
                        left: 8,
                        top: "50%",
                        transform: "translateY(-50%)"
                      }}
                    />
                  )}
                </div>
              </div>   <div className="form-group mb-3">
                <label htmlFor="phoneInput">{t("local_sim.identity_check.phone")}</label>
                <div className="d-flex gap-3 align-items-center input_bg mt-3" dir="rtl">
                  <input
                    id="phoneInput"
                    className={`form-control form-control-lg${errorNumber ? " is-invalid" : ""}`}
                    style={{ fontSize: '1.25rem', border: 0 }}
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    required
                    type="tel"
                    placeholder="5xxxxxxxx"
                    pattern="[0-9]{9,15}"
                  />
                  <div className="country-code d-flex align-items-center px-3" style={{ height: "83px" }}>
                    <div className="country-flag">
                      <img src="https://flagcdn.com/sa.svg" alt="flag" />
                    </div>
                    <div className="country-code-text">+{selectedCode}</div>
                  </div>
                </div>
                {errorNumber && <p className="text-danger mt-3">{errorNumber}</p>}
              </div>
            </div>
 
            <button type="submit" disabled={state.submitting} className="button mt-4">
              {t("fixedService.login.submit")}
            </button>
            <input
              type="hidden"
              name="nationality"
              value={selectedIdentity ? (i18n.language === "ar" ? selectedIdentity.nameAr : selectedIdentity.nameEN) : ""}
/>
          </form>
          {/* //width 971</> */}

          {/* Modal for country selection */}
          <Modal show={showCountryModal} onHide={() => setShowCountryModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>{t("fixedService.services.nationality")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <input
                type="text"
                className="form-control mb-3"
                placeholder={t("local_sim.identity_check.search_placeholder") ?? ""}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                {filteredIdentities.map((identity) => (
                  <div
                    key={identity.id}
                    className="country-option d-flex gap-3 p-2 align-items-center"
                    onClick={() => {
                      setSelectedIdentity(identity);
                      setShowCountryModal(false);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={identity.flagImageUrl}
                      alt={identity.nameEN}
                      style={{ width: "30px" }}
                    />
                    <span>{i18n.language === "ar" ? identity.nameAr : identity.nameEN}</span>
                    {selectedIdentity?.id === identity.id && (
                      <span className="ml-2 text-success">({t("global.selected") || "Selected"})</span>
                    )}
                  </div>
                ))}
              </div>
            </Modal.Body>
          </Modal>
          </>
        );
      };
      
      const Indicators = ({ active, length }: { active: number, length: number }) => {
        return (

          <div className="indicators">
            {Array.from({ length }).map((_, index) => {
              return (
                <div
                  className={`indicator rounded-pill col ${
                    (index > active || active >= length) && active !==3  ? "not_active" : "active"
                  }`}
                  key={index}
                ></div>
              );
            })}
          </div>
        );
      };
    
      const SuccessDialog = ({ show, onHide }: { show: boolean; onHide: () => void }) => {
        const { t } = useTranslation();
        
        return (
          <Modal
            show={show}
            onHide={onHide}
            centered
            className="success-dialog modal_store_info"
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("fixedService.created_successfully")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex h-100 align-items-center justify-content-center flex-column">
                  <img src="/media/gifs/done.gif" className="w-50"/>
                <div className="pb-5 fs-4 text-center">
                  {t("fixedService.soon") + " " + t("fixedService.order_number") + " #12345"}
                </div>
              </div>
             
            </Modal.Body>
          </Modal>
        );
      };
